import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "dark" | "light";
};
export function Countdown({
  tone = "dark"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const onDark = tone === "light";
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c3z14y5dj0ca">
      <p className={`flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-wider ${onDark ? "text-teal-light" : "text-navy"}`} data-id="element-20" data-mp="3h1qorfyzk0ao">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="372t7my3w391p" />
        The special launch offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-22" data-mp="10clc4kxpq8az">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="15by75syqmlon" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="15awj8nwmi4pi">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-3xl font-extrabold tabular-nums sm:h-[72px] sm:w-[72px] sm:text-4xl ${onDark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-25" data-mp="y0n1tq0onbb3">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${onDark ? "text-white/70" : "text-ink-muted"}`} data-id="element-26" data-mp="12seuq77b9t4e">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-serif text-3xl font-bold ${onDark ? "text-white" : "text-navy"}`} data-id="element-27" data-mp="o2qu786yeyhq">:</span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-3 text-sm ${onDark ? "text-white/70" : "text-ink-muted"}`} data-id="element-28" data-mp="k3hxpvkj4mih">Limited introductory pricing available.</p>
    </div>;
}